module.exports = __webpack_public_path__ + "static/nextdoor-icon-c253030620a62f3f7cfe5e6bf1e8ae84.png";